export default __webpack_public_path__ + "static/media/HUD-Effects-01.04fd06fc.jpg";